<template>
  <div class="auth-wrapper registration">
    <div v-if="!isMobile" class="auth-wrapper auth-wrapper-left"></div>

        <div class="auth-wrapper-rigth">
            <div class="auth-wrapper__content">
        <div class="auth-wrapper__logo logo">
                    <figure class="figure-logo">
                        <img src="/static/logos/logo_dv7.png" alt="40%" width="80%">
                    </figure>
                </div>
      <lang-select class="set-language"/>
      <el-form
        :model="model"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="0px"
        :class="{'login-container': !isMobile, 'login-container-mobile': isMobile}"
        @submit.native.prevent
      >
        <el-form-item prop="email">
          <el-input
            :disabled="!!defaultEmail"
            type="text"
            v-model="model.email"
            @keyup.enter.native="submit"
            auto-complete="off"
            :placeholder="$t('auth.registerManager.email')"
            ref="focus"
          ></el-input>
        </el-form-item>

      <el-form-item prop="password">
          <el-input
            type="password"
            v-model="model.password"
            @keyup.enter.native="submit"
            auto-complete="off"
            :placeholder="$t('auth.registerManager.password')"
          ></el-input>
        </el-form-item>
        <el-form-item  prop="name">
            <el-input
              v-model="model.name"
            ref="focus"
            :placeholder="$t('auth.registerManager.name')"
            />
        </el-form-item>

        <el-form-item  prop="lastName">
            <el-input
              v-model="model.lastName"
            :placeholder="$t('auth.registerManager.lastName')"
              ref="focus"
            />
        </el-form-item>

        <el-form-item  prop="phone">
            <el-input
              v-model="model.phone"
            :placeholder="$t('auth.registerManager.phone')"
              ref="focus"
            />
        </el-form-item>
        <el-form-item>
          <template>
            <!-- `checked` debe ser true o false -->
            <el-checkbox v-model="checked">{{$t('auth.registerManager.accept')}}</el-checkbox>
            <!-- <router-link type="text" :to="{ name: 'termsConditions' }">{{$t('auth.registerManager.termnsConditions')}}</router-link> -->
            <!-- <span>&</span> -->
            <router-link type="text" :to="{ name: 'privacyPolicy' }">{{$t('auth.registerManager.privacyPolicy')}}</router-link>
          </template>
        </el-form-item>
        <el-form-item style="width:100%;">
          <el-button
            type="primary"
            style="width:100%;"
            @click="submit"
            :loading="loading"
            :disabled="!checked"
          >{{$t('auth.registerManager.createAccount')}}</el-button>
        </el-form-item>
        <el-form-item class="text-center">
          <router-link :to="{ name: 'login' }">{{$t('auth.registerManager.cancel')}}</router-link>
        </el-form-item>
      </el-form>
    </div>
        </div>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import validators from "@/shared/form/validators";
import LangSelect from '@/components/LangSelect'

export default {
  name: "app-registration",
  components: {
    LangSelect
  },
  data() {
    return {
      rules: {
        email: validators.string({ label:  this.$t('auth.registerManager.email'), required: true, min: 1 }),
        password: validators.string({
          label: this.$t('auth.registerManager.password'),
          required: true,
          max: 255
        }),
        name: validators.string({
          label: this.$t('auth.registerManager.name'),
          required: true
        }),
        lastName: validators.string({
          label: this.$t('auth.registerManager.lastName'),
          required: true
        }),
        phone: validators.string({
          label: this.$t('auth.registerManager.phone'),
          required: true,
        }),
      },
      model: {},
      checked: false
    };
  },

  computed: {
    ...mapGetters({
      loading: "auth/loading",
      isMobile: "shared/isMobile"
    }),

    defaultEmail() {
      return this.$route.query.email || null;
    }
  },

  created() {
    if (this.defaultEmail) {
      this.model.email = this.defaultEmail;
    }
  },

  methods: {
    submit() {
      this.$refs.form.validate().then(valid => {
        if (!valid) {
          return;
        }

        this.$store
          .dispatch("auth/registerManager", 
            this.model
          )
          .then(() => {
            this.$router.push("/");
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.set-language {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size:20px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/auth/registration/registrationManager.vue?7f9c1b37